import { Component, Input } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { ActivityRegistryDto } from '../activity-registry-service/activity-registry-dto';
import { ActivityRegistryService } from '../activity-registry-service/activity-registry.service';

@Component({
  selector: 'lp2-activity-registry',
  templateUrl: './activity-registry.component.html',
  styleUrls: ['./activity-registry.component.scss'],
})
export class ActivityRegistryComponent {
  @Input()
  gamificationEnabled = false;

  isLoading = true;
  activityRegistryData: ActivityRegistryDto;
  liveClassEnabled: boolean;

  get activityItems() {
    if (!this.activityRegistryData) {
      return [];
    }

    const items = [
      {
        imageSource: '../images/activity-registry/hot-streak.svg',
        count: this.activityRegistryData.hotStreakCount,
        titleKey: 'progress.hotStreak',
        show: true,
      },
      {
        imageSource: '../images/activity-registry/clases-en-vivo.svg',
        count: this.activityRegistryData.liveClasses,
        titleKey: 'progress.liveClasses',
        show: this.liveClassEnabled,
      },
      {
        imageSource: '../images/activity-registry/unidades.svg',
        count: this.activityRegistryData.units,
        titleKey: 'progress.units',
        show: this.oeAppPerson.lessonEnabled,
      },
      {
        imageSource: '../images/activity-registry/practicas.svg',
        count: this.activityRegistryData.practiceHours,
        titleKey: 'progress.practice',
        show: true,
      },
      {
        imageSource: '../images/activity-registry/clases-privadas.svg',
        count: this.activityRegistryData.privateClasses,
        titleKey: 'progress.privateClasses',
        show: this.liveClassEnabled,
      },
    ];

    return items.filter((item) => item.show);
  }

  constructor(activityRegistryService: ActivityRegistryService, private readonly oeAppPerson: OeAppPersonService) {
    this.isLoading = true;
    const personId = this.oeAppPerson.id;
    activityRegistryService.getActivityRegistryData(personId).subscribe((response) => {
      this.activityRegistryData = response;
      this.isLoading = false;
    });
    this.liveClassEnabled = this.oeAppPerson.liveClassEnabled;
  }
}



// WEBPACK FOOTER //
// ./ts/app/activity-registry/activity-registry/activity-registry.component.ts